export class Diagnostics {
  constructor(limit = 300) {
    this.limit = limit;
    this.entries = [];
    this.state = {};
    this.onChange = null;
  }

  set(key, value) {
    this.state[key] = value;
    this.onChange?.(this.snapshot());
  }

  event(kind, details = {}) {
    this.entries.push({ at: new Date().toISOString(), kind, ...details });
    if (this.entries.length > this.limit) this.entries.splice(0, this.entries.length - this.limit);
    this.onChange?.(this.snapshot());
  }

  snapshot() {
    return { format: 1, generatedAt: new Date().toISOString(), state: structuredClone(this.state), entries: structuredClone(this.entries) };
  }

  export(filename = `lumichat-diagnostic-${new Date().toISOString().replaceAll(':', '-')}.json`) {
    const blob = new Blob([`${JSON.stringify(this.snapshot(), null, 2)}\n`], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
